var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bf problem-box",
    style: {
      height: _vm.menuHeight
    }
  }, [!_vm.listPending && _vm.cateList && _vm.cateList.length ? _c('div', {
    staticClass: "problem-box-left"
  }, [_c('div', {
    staticClass: "problem-box-title"
  }, [_c('h2', [_c('span', [_vm._v(_vm._s(_vm.channelBreadCrump.title))])])]), _c('a-skeleton', {
    attrs: {
      "loading": _vm.listPending,
      "active": ""
    }
  }, [_vm.cateList && _vm.cateList.length ? _c('a-collapse', {
    ref: "menuCollapseRef",
    staticClass: "gd-scrollbar problem-box-menu",
    attrs: {
      "bordered": false,
      "expandIconPosition": "right",
      "active-key": _vm.activeKeys
    }
  }, _vm._l(_vm.cateList, function (cat1) {
    return _c('a-collapse-panel', {
      key: String(cat1.id),
      attrs: {
        "show-arrow": !!(cat1.children && cat1.children.length),
        "header": cat1.title
      }
    }, _vm._l(cat1.children, function (cat2) {
      return _c('p', {
        key: cat2.id,
        staticClass: "problem-box-link",
        class: {
          active: cat2.id == _vm.cateId
        },
        on: {
          "click": function ($event) {
            return _vm.handleCateClick(cat2, cat1);
          }
        }
      }, [_c('a-icon', {
        staticStyle: {
          "font-size": "10px"
        },
        attrs: {
          "type": "caret-right"
        }
      }), _vm._v(" " + _vm._s(cat2.title) + " ")], 1);
    }), 0);
  }), 1) : _vm._e()], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "ml-10 problem-box-main"
  }, [!_vm.listPending && _vm.breadCrumpList.length ? _c('div', {
    staticClass: "problem-box-main-header"
  }, [_c('a-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, _vm._l(_vm.breadCrumpList, function (item) {
    return _c('a-breadcrumb-item', {
      key: item.id
    }, [!item.id ? [_vm._v(_vm._s(item.title))] : _c('router-link', {
      attrs: {
        "to": {
          name: 'FaqListPage',
          query: {
            cate_id: item.id,
            channel: _vm.$route.query.channel
          },
          params: _vm.routeParams
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 2);
  }), 1), _c('tip', {
    staticClass: "mt-10"
  })], 1) : _vm._e(), _vm.listPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e(), _c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.listPending,
      expression: "!listPending"
    }],
    on: {
      "toggleBreadCrump": _vm.toggleBreadCrump,
      "toggleChannel": _vm.toggleChannel,
      "toggleCateId": _vm.toggleCateId
    }
  })], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };